import { Box, styled } from '@mui/material';
import { spaceCadet } from '../../../../../../../../../../utils/colors';

const StyledBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  padding: 8,
  border: `1px solid ${spaceCadet[300]}`,
  borderRadius: 4,
  gap: 0,
  '& > .MuiTypography-subtitle1': {
    fontSize: 14,
  },
});

export default StyledBox;
